import { useEffect } from "react";
import { Flex, Text } from "styles/utility-components";

import { DetailsHeader, DetailsPage } from "components/app_layout/DetailsLayout";
import { BuyerFilterSections } from "components/buyers/BuyerFilterForm";
import { FilterableBuyerTable } from "components/buyers/FilterableBuyerTable";
import { DEFAULT_BUYER_FILTERS } from "components/buyers/useFilterableBuyerTableState";
import { PaywallBanner } from "components/paywall/PaywallBanner";
import Button from "components/ui/button/Button";
import { appRoutes } from "lib/appRoutes";
import { useVariableValue } from "lib/featureFlags";
import { useLogSearchOfURLFilters } from "lib/hooks/api/userActivity/useLogSearch";
import { useSubscription } from "lib/hooks/subscription";
import { TrackingProvider } from "lib/tracking";
import { LoggedEntityType } from "lib/types/graphQLEnums";

import css from "./BuyersPage.module.scss";

export function BuyersPage() {
  useEffect(() => {
    document.title = "Find buyers";
  }, []);
  useLogSearchOfURLFilters(LoggedEntityType.Buyer, "buyerFilters");

  const isSignalFiltersEnabled = useVariableValue("organisations-signal-filtering", false);
  const hiddenSections: BuyerFilterSections[] = isSignalFiltersEnabled ? [] : ["signals"];

  const subscription = useSubscription();
  const hasBuyerAccess = subscription.hasDataTypes("BUYERS");

  return (
    <DetailsPage>
      <DetailsHeader>
        <Flex justifyContent="space-between" alignItems="center">
          <Text h1>Find buyers</Text>
          <Button as="a" {...appRoutes.buyerLists} buttonType="secondary" icon="list">
            Buyer lists
          </Button>
        </Flex>
      </DetailsHeader>
      {hasBuyerAccess ? (
        <TrackingProvider data={{ "Context source": "In-row" }}>
          <div className={css.buyerTable}>
            <FilterableBuyerTable
              defaultFilters={DEFAULT_BUYER_FILTERS}
              hiddenSections={hiddenSections}
            />
          </div>
        </TrackingProvider>
      ) : (
        <PaywallBanner featureType="BUYERS" />
      )}
    </DetailsPage>
  );
}
